module.exports = __webpack_public_path__ + "img/five3Blue.5ec2a0b6.jpg";